import type { FeedLog } from '@/types';

/** 7-day weight polyline with area fill + draw-in animation (HANDOFF anim #28). */
export function WeightChart({ logs }: { logs: FeedLog[] }) {
  const cutoff = Date.now() - 7 * 86400000;
  const points = logs
    .filter((l) => l.weight_g != null && new Date(l.fed_at).getTime() > cutoff)
    .map((l) => ({ t: new Date(l.fed_at).getTime(), w: l.weight_g! }))
    .sort((a, b) => a.t - b.t);

  if (points.length < 2) return null;

  const W = 280, H = 84, PAD = 6;
  const t0 = points[0].t, t1 = points[points.length - 1].t;
  const ws = points.map((p) => p.w);
  const wMin = Math.min(...ws), wMax = Math.max(...ws);
  const span = wMax - wMin || 1;
  const xy = points.map((p) => {
    const x = PAD + ((p.t - t0) / (t1 - t0 || 1)) * (W - PAD * 2);
    const y = H - 12 - ((p.w - wMin) / span) * (H - 24);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const last = xy[xy.length - 1].split(',');

  const dayLabels: string[] = [];
  for (let i = 6; i >= 0; i--) {
    dayLabels.push(new Date(Date.now() - i * 86400000).toLocaleDateString([], { weekday: 'short' }));
  }

  return (
    <div class="card weight-chart" style={{ padding: '14px' }}>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="84" aria-label="Weight trend, last 7 days">
        <polyline
          points={`${xy.join(' ')} ${last[0]},${H} ${xy[0].split(',')[0]},${H}`}
          fill="var(--brand-primary-light)"
          stroke="none"
        />
        <polyline
          class="line"
          points={xy.join(' ')}
          fill="none"
          stroke="var(--brand-primary)"
          stroke-width="2.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx={last[0]} cy={last[1]} r="4" fill="var(--brand-primary)" />
      </svg>
      <div class="weight-chart__labels">
        {dayLabels.map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>
    </div>
  );
}
